@if ((entityConfig?.responsive[shareSvc.currentScreenSize])?.displayMode=='dropdown') {
  <button (click)="dropDownOpen=!dropDownOpen" class="dropdown-controller d-flex align-items-center"
    [class.open-dropdown]="dropDownOpen">
    <span>{{selectedItemText || anchorsList[0]?.name}}</span>
    <svg class="dropdown-controller-indicator" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path fill="none" stroke="currentColor" d="M5 7.5 L10 12.5 L15 7.5"/>
    </svg>
  </button>
}
<nav class="toc-menu" [attr.aria-label]="'Table Of Contents' | translate" [class.d-none]="(entityConfig?.responsive[shareSvc.currentScreenSize])?.displayMode=='dropdown'&&!dropDownOpen">
  <ul class="toc-menu-items" #scrollerEl [ngClass]="{'horizontal-scroller hide-scrollbar': mobileHS && shareSvc.isMediaQueryMatched(mobileHS)}">
    @for (link of anchorsList; track link) {
      <li class="toc-menu-item" [class.active]="link.active">
        <!--<a (click)="scrollToTarget(link.targetId)">{{link.name}}</a>-->
        @if (!link.outerLink?.startsWith('http')) {
          <a [class]="'anchor-el '+link.className"
            [routerLink]="link.outerLink ? [link.outerLink] : []"
            [fragment]="link.outerLink ? null : link.targetId"
            (click)="onPointerClick(link.targetId, $event)">
            @if (link.imageSrc) {
              <img [src]="link.imageSrc" alt="">
            }
            {{link.name}}
          </a>
        }
        @if (link.outerLink?.startsWith('http')) {
          <a [href]="link.outerLink" [class]="'anchor-el '+link.className" target="{{externalLinkSameTab ? null : '_blank'}}">
            @if (link.imageSrc) {
              <img [src]="link.imageSrc" alt="">
            }
            {{link.name}}
          </a>
        }
        <!--<button (click)="scrollToTarget(link.targetId)" [class]="'anchor-el '+link.className">-->
        <!--<img *ngIf="link.imageSrc" [src]="link.imageSrc" alt="">-->
        <!--{{link.name}}-->
      <!--</button>-->
    </li>
  }
</ul>
</nav>